<!-- prettier-ignore -->
<div class="d-flex flex-row position-relative align-items-center content-small">
  <div
    *ngIf="imgLoadError === true"
    class="content-small--image content-small--image__fallback"
  ></div>
  <div
    *ngIf="imgLoadError === false && overlayCaption !== undefined"
    class="img-overlay-badge img-badge-position caption position-absolute"
  >
    {{ overlayCaption }}
  </div>
  <img
    *ngIf="imgLoadError === false"
    class="content-small--image"
    [src]="imgUrl"
    [alt]="title"
    (error)="imgLoadError = true"
    loading="lazy"
  />
  <div class="content-small--info">
    <h3 class="headline text-800 font-family-bold mb-1 apply-text-hover text-line-clamp-2">
      {{ title }}
    </h3>
    <p class="subhead color-500"
       *ngIf="publishDate !== null"
    >
      {{ publishDate | date: 'mediumDate' }}
    </p>
  </div>
</div>
